"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useApply = void 0;
var axios_1 = __importDefault(require("axios"));
var react_1 = require("react");
var useApply = function () {
    var _a = (0, react_1.useState)(true), isPresentLoading = _a[0], setIsPresentLoading = _a[1];
    var _b = (0, react_1.useState)(null), holdingStatus = _b[0], setHoldingStatus = _b[1];
    var _c = (0, react_1.useState)(), contentData = _c[0], setContentData = _c[1];
    var _d = (0, react_1.useState)(true), isAppliedLoading = _d[0], setIsAppliedLoading = _d[1];
    var _e = (0, react_1.useState)(false), isApplied = _e[0], setIsApplied = _e[1]; // 応募済み：true、未応募：false
    // 開催状況チェック
    (0, react_1.useEffect)(function () {
        axios_1.default
            .get("/api/present/config")
            .then(function (response) {
            setContentData(response.data.contents);
            setHoldingStatus(response.data.type);
        })
            .finally(function () {
            setIsPresentLoading(false);
        });
    }, []);
    // 応募状況チェック
    (0, react_1.useEffect)(function () {
        axios_1.default
            .get("/api/present/applied", {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
        })
            .then(function (response) {
            setIsApplied(response.data.isApplied);
        })
            .catch(function (_a) {
            var response = _a.response;
            console.log("error");
        })
            .finally(function () {
            setIsAppliedLoading(false);
        });
    }, []);
    return {
        isPresentLoading: isPresentLoading,
        isAppliedLoading: isAppliedLoading,
        isApplied: isApplied,
        contentData: contentData,
        holdingStatus: holdingStatus,
    };
};
exports.useApply = useApply;
